import Vue, { PropType } from 'vue';
import { AxiosRequestConfig } from 'axios';

import { Eフェーズ種別 } from '@/openapi/enum';

export default Vue.extend({
  name: 'Mフェーズ種別Mixin',

  props: {
    eフェーズ種別: {
      type: Number as PropType<Eフェーズ種別>,
      required: true,
    },
  },

  computed: {
    apiフェーズ種別(): Eフェーズ種別 | undefined {
      return this.eフェーズ種別 === Eフェーズ種別.分析フェーズ ? Eフェーズ種別.分析フェーズ : undefined;
    },
  },

  methods: {
    isCurrentフェーズ種別(item: { フェーズ種別: Eフェーズ種別 }): boolean {
      return this.eフェーズ種別 === item.フェーズ種別;
    },
    mockApiOptions(name: string, withSuffix = false): AxiosRequestConfig | undefined {
      if (process.env.VUE_APP_IS_MOCK !== 'true') return undefined;
      if (this.eフェーズ種別 === Eフェーズ種別.モニタリングフェーズ) throw Error;
      return {
        params: {
          sj: withSuffix ? `${name}_${this.eフェーズ種別 === Eフェーズ種別.分析フェーズ ? '分析' : '計画'}` : name,
        },
      };
    },
  },
});
